import { useRef, useState } from "react";

import "./AdjuntosCard.css";

export default function AdjuntosCard({
  campaign,
  setCampaign,
}) {
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  const attachments = Array.isArray(campaign.attachments)
    ? campaign.attachments
    : [];

  function addFiles(fileList) {
    const files = Array.from(fileList || []);

    if (files.length === 0) return;

    setCampaign((previousCampaign) => ({
      ...previousCampaign,
      attachments: [
        ...(Array.isArray(previousCampaign.attachments)
          ? previousCampaign.attachments
          : []),
        ...files,
      ],
    }));
  }

  function handleFilesSelected(event) {
    addFiles(event.target.files);
    event.target.value = "";
  }

  function handleDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(true);
  }

  function handleDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();

    if (event.currentTarget.contains(event.relatedTarget)) {
      return;
    }

    setDragActive(false);
  }

  function handleDrop(event) {
    event.preventDefault();
    event.stopPropagation();

    setDragActive(false);
    addFiles(event.dataTransfer.files);
  }

  function removeAttachment(index) {
    setCampaign((previousCampaign) => ({
      ...previousCampaign,
      attachments: (
        Array.isArray(previousCampaign.attachments)
          ? previousCampaign.attachments
          : []
      ).filter((_, attachmentIndex) => attachmentIndex !== index),
    }));
  }

  function formatSize(bytes) {
    if (!bytes) return "0 KB";

    if (bytes < 1024 * 1024) {
      return `${(bytes / 1024).toFixed(1)} KB`;
    }

    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }

  const totalSize = attachments.reduce(
    (total, file) => total + Number(file?.size || 0),
    0,
  );

  return (
    <section className="campaign-card attachments-card">
      <div className="campaign-card-header">
        <div className="campaign-card-title">
          <span className="campaign-card-icon">
            <i className="fa-solid fa-paperclip" aria-hidden="true" />
          </span>

          <div>
            <h2>Archivos adjuntos</h2>

            <p>
              Añade documentos, imágenes o PDF para enviarlos junto al correo.
            </p>
          </div>
        </div>
      </div>

      <input
        ref={inputRef}
        type="file"
        multiple
        className="attachment-input"
        onChange={handleFilesSelected}
      />

      <button
        type="button"
        className={`attachment-upload${dragActive ? " drag-active" : ""}`}
        onClick={() => inputRef.current?.click()}
        onDragEnter={handleDragOver}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <i className="fa-solid fa-cloud-arrow-up" aria-hidden="true" />

        <span className="attachment-upload-copy">
          <strong>Arrastra archivos aquí</strong>
          <small>o pulsa para seleccionarlos</small>
        </span>
      </button>

      <div className="attachment-summary">
        <span>
          {attachments.length === 0
            ? "Sin archivos adjuntos"
            : `${attachments.length} ${
                attachments.length === 1 ? "archivo" : "archivos"
              }`}
        </span>

        {attachments.length > 0 && (
          <span>{formatSize(totalSize)}</span>
        )}
      </div>

      {attachments.length > 0 && (
        <div className="attachment-list">
          {attachments.map((file, index) => (
            <div
              key={`${file.name}-${file.size}-${index}`}
              className="attachment-item"
            >
              <div className="attachment-info">
                <span className="attachment-file-icon">
                  <i className="fa-solid fa-file" aria-hidden="true" />
                </span>

                <div className="attachment-file-copy">
                  <strong title={file.name}>{file.name}</strong>
                  <small>{formatSize(file.size)}</small>
                </div>
              </div>

              <button
                type="button"
                className="attachment-remove"
                onClick={() => removeAttachment(index)}
                aria-label={`Eliminar ${file.name}`}
                title="Eliminar archivo"
              >
                <i className="fa-solid fa-trash" aria-hidden="true" />
              </button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}